import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LoadScreenComponent} from "./load-screen.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LoadScreenComponent],
  exports: [LoadScreenComponent]
})
export class LoadScreenModule { }
